import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { InvitationResponse } from '@pages/set-password/models/invitation-response.interface';
import { SetUserPasswordRequest } from '@pages/set-password/models/set-user-password-request.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SetPasswordService {
  private readonly httpClient = inject(HttpClient);

  validateInvitationCode(invitationToken: string): Observable<InvitationResponse> {
    const url = `api/v3/users/user/invitation/${invitationToken}`;

    return this.httpClient.get<InvitationResponse>(environment.portalApiUrl + url);
  }

  setPassword(request: SetUserPasswordRequest): Observable<void> {
    const url = 'api/v3/user/password';

    return this.httpClient.post<void>(environment.portalApiUrl + url, request);
  }
}
